import {
  ArrowPathIcon,
  MinusCircleIcon,
  ArrowUpTrayIcon,
  ArchiveBoxIcon,
  PlayIcon,
} from "@heroicons/react/24/outline";
import Spinner from "../../../shared/components/ui/Spinner";

export default function ArchiveStatusSection({ archiveStatus, showRain }) {
  if (!archiveStatus) {
    return (
      <div className="stats-loading-section">
        <Spinner size="md" />
        Loading archive status...
      </div>
    );
  }

  // V2: exported_count replaces to_archive_count
  const { queue_length, current_job, exported_count, archived_count, recent_archives } =
    archiveStatus;
  const isRunning = queue_length > 0 || current_job;

  return (
    <div className={`archive-stats-grid ${showRain ? "matrix-grid" : ""}`}>
      {/* Summary row */}
      <div className="stat-cards-grid">
        <div className={`stat-card ${isRunning ? "active" : ""}`}>
          <div className={`stat-icon ${isRunning ? "pulse" : ""}`}>
            {isRunning ? (
              <ArrowPathIcon />
            ) : (
              <MinusCircleIcon />
            )}
          </div>
          <span className="stat-value">{queue_length || 0}</span>
          <span className="stat-label">Jobs in Queue</span>
        </div>
        <div className="stat-card done">
          <div className="stat-icon">
            <ArrowUpTrayIcon />
          </div>
          <span className="stat-value">{exported_count || 0}</span>
          <span className="stat-label">Exported</span>
        </div>
        <div className="stat-card info">
          <div className="stat-icon">
            <ArchiveBoxIcon />
          </div>
          <span className="stat-value">{archived_count || 0}</span>
          <span className="stat-label">Archived</span>
        </div>
        {current_job && (
          <div className="stat-card processing">
            <div className="stat-icon pulse">
              <PlayIcon />
            </div>
            <span className="stat-value">{current_job.image_count}</span>
            <span className="stat-label">Current Job</span>
          </div>
        )}
      </div>

      {/* Recent archives list */}
      <div className="stats-subsection">
        <h3>Recent Archives</h3>
        {recent_archives?.length > 0 ? (
          <div className="stats-list">
            {recent_archives.map((archive) => (
              <div key={archive.archive_name} className="stats-list-item">
                <span className="item-name">{archive.archive_name}</span>
                <span className="item-meta">
                  {archive.archived_count} images | {archive.size_mb} MB
                  {archive.failed_count > 0 && (
                    <span style={{ color: "#ff6b6b" }}> | {archive.failed_count} failed</span>
                  )}
                </span>
                <span className="item-value">
                  {archive.completed_at ? new Date(archive.completed_at).toLocaleString() : "-"}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-data">No recent archives</div>
        )}
      </div>
    </div>
  );
}
